import Spinner from '@rio-cloud/rio-uikit/Spinner';

export const Loader = () => (
    <div className='margin-25' data-testid='loading-spinner'>
        <Spinner />
    </div>
);
